const tabuleoSubscription = {
  tabuleoSubscriptions: "Abonnements für Tabuléo",
  nbStudentTeacher: "Anzahl der Lernenden und Lehrkräfte",
  getSubscriptionsError: "Fehler beim Laden der Tabuléo-Abonnements.",
  getSubscriptionError: "Fehler beim Laden der Einrichtungsdetails.",
  nbrStudent: "Anzahl der Lernenden",
  nbrTeacher: "Anzahl der Lehrkräfte",
};

export default tabuleoSubscription;
